import { TryCart } from "@/app/services";
import { TryCartState, clearTryCart, startLoading, startTryCartFetching, stopLoading, stopTryCartFetching, updateTryCart } from "./tryCartSlice";
import { urlWithQueryParams } from "@/app/utils";
import { toast } from "sonner";
import { AppDispatch } from "@v2/lib/redux/store";

const addToTryBasketThunk =
	(productId: number): any =>
	async (dispatch) => {
		const tryBasket = new TryCart();
		dispatch(startLoading());
		try {
			const res = await tryBasket.addToCart(productId);
			dispatch(stopLoading());
			dispatch(updateTryCart(res?.data));
			// ToastMessage.success(`محصول مورد نظر به سبد پرو اضافه گردید.`);
		} catch (e) {
			dispatch(stopLoading());
		}
	};

const submitTryBasketThunk =
	(tryCart: TryCartState): any =>
	async (dispatch) => {
		const tryBasket = new TryCart();
		dispatch(startLoading());
		try {
			const res = await tryBasket.submit(tryCart);
			dispatch(stopLoading());
			dispatch(clearTryCart());
			toast.success(`درخواست ثبت سبد پرو با موفقیت انجام گردید.`);
			window.location.href = urlWithQueryParams(`/try/final/result`, {
				cartId: res?.data?.id,
			});
		} catch (e) {
			dispatch(stopLoading());
			throw new Error(`خطایی صورت گرفته است!`);
		}
	};

const getTryCartThunk = (): any => async (dispatch: AppDispatch) => {
	const tryBasket = new TryCart();
	dispatch(startTryCartFetching());
	try {
		const res = await tryBasket.getCart();
		dispatch(stopTryCartFetching());
		dispatch(updateTryCart(res?.data));
		return res?.data;
	} catch (e) {
		dispatch(stopTryCartFetching());
		throw e;
	}
};

const removeFromTryCartThunk =
	(productId: number): any =>
	async (dispatch) => {
		const tryBasket = new TryCart();
		dispatch(startLoading());
		try {
			const { data: tryCartData } = await tryBasket.remove(productId);
			dispatch(stopLoading());
			dispatch(updateTryCart(tryCartData));
			// ToastMessage.success(`محصول مورد نظر از سبد پرو حذف گردید.`);
		} catch (e) {
			dispatch(stopLoading());
			throw new Error(`خطایی صورت گرفته است!`);
		}
	};

const clearTryBasketCartThunk = (): any => async (dispatch) => {
	const tryBasket = new TryCart();
	try {
		dispatch(startLoading());
		await tryBasket.clear();
		dispatch(stopLoading());
		dispatch(clearTryCart());
	} catch (error) {
		dispatch(stopLoading());
		toast.error("خطایی هنگام پاک شدن سبد پرو رخ داده است");
	}
};

export { removeFromTryCartThunk, addToTryBasketThunk, submitTryBasketThunk, getTryCartThunk, clearTryBasketCartThunk };
